<div class="modal-header border-0 pb-0">
  <h1 class="main-content-label fw-bold mb-0" style="color: #4939f7; font-size: 1.2rem;">
    <i class="fa fa-layer-group me-2" style="color: #1b07f0;"></i>
    Optional Subject Selection
  </h1>
</div>
<br>
<div class="modal-body">
  <form autocomplete="off" novalidate [formGroup]="subjectForm">
    <div class="row clearfix mt-3">
      <div class="row clearfix">
        <div class="col-sm-2">
          <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Session</mat-label>
              <mat-select #selectSession placeholder="Session" class="colorblack" formControlName="SubSession" disabled>
                <mat-select-filter *ngIf="selectSession.focused" [placeholder]="'Filter'" [displayMember]="'SnName'"
                  [array]="sessionList" (filteredReturn)="filteredSessionList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let item of filteredSessionList" [value]="item.SnNo">
                  {{item.SnName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Faculty</mat-label>
              <mat-select #selectFaculty placeholder="Faculty" class="colorblack" formControlName="SubFacId" disabled>
                <mat-select-filter *ngIf="selectFaculty.focused" [placeholder]="'Filter'" [displayMember]="'FcDesc'"
                  [array]="facultyList" (filteredReturn)="filteredFacultyList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let item of filteredFacultyList" [value]="item.FcCode">
                  {{item.FcDesc}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Course</mat-label>
              <mat-select #selectCourse placeholder="Course" class="colorblack" formControlName="SubCoId" disabled>
                <mat-select-filter *ngIf="selectCourse.focused" [placeholder]="'Filter'" [displayMember]="'CoName'"
                  [array]="courseList" (filteredReturn)="filteredCourseList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode">
                  {{item.CoName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Branch</mat-label>
              <mat-select #selectBranch placeholder="Branch" class="colorblack" formControlName="SubBrId" disabled>
                <mat-select-filter *ngIf="selectBranch.focused" [placeholder]="'Filter'" [displayMember]="'StrName'"
                  [array]="courseStreamList" (filteredReturn)="filteredStreamList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let item of filteredStreamList" [value]="item.StrId">
                  {{item.StrName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Exam</mat-label>
              <mat-select #selectExam class="colorblack" formControlName="SubEmId"
                (selectionChange)="onExamChange($event.value)">
                <mat-select-filter *ngIf="selectExam.focused" [placeholder]="'Filter'" [displayMember]="'EmName'"
                  [array]="examList" (filteredReturn)="filteredExamList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let item of filteredExamList" [value]="item.EmId">
                  {{item.EmName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="form-group">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>College</mat-label>
              <mat-select #selectCollege class="colorblack" formControlName="SubCgId" disabled>
                <mat-select-filter *ngIf="selectCollege.focused" [placeholder]="'Filter'" [displayMember]="'CgName'"
                  [array]="collegeList" (filteredReturn)="filteredCollegeList = $event">
                </mat-select-filter>
                <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode">
                  {{item.CgName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3" *ngIf="getValidationErrorsKeys().length > 0">
      <div *ngFor="let errorCode of getValidationErrorsKeys()">
        <p style="color: red; font-weight: 600;">{{ validationErrors[errorCode] }}</p>
      </div>
    </div>

    <div class="row clearfix mt-3">
      <div class="col-sm-12">
        <div class="flex-container">
          <div *ngIf="OptSub && GroupData.length > 0">
            <div class="card-container" style="display: flex; flex-direction: row; flex-wrap: wrap;">
              <mat-card *ngFor="let group of GroupData" class="example-card2" style="margin: 10px; min-width: 280px;">
                <mat-checkbox *ngIf="group.EsOpCode && group.EsOpCode !== ' '"
                  [disabled]="group.EsOpCode === ' '"
                  [checked]="shouldCheckItemForGroup(group) || group.EsOpCode === ' '"
                  (change)="onCheckboxChanged($event, group)">
                  <h5>{{ group.EsCode }} - {{ group.EsName }}
                    <b *ngIf="group.EsOpCode !== ' '">(Option : {{group.EsOpCode}})</b>
                  </h5>
                </mat-checkbox>
                <h5 *ngIf="!group.EsOpCode || group.EsOpCode === ' '">
                  {{ group.EsCode }} - {{ group.EsName }}
                </h5>
                <div *ngIf="group.EsOpCode && group.EsOpCode !== ' '">
                  <ng-container *ngIf="getOptForCode(group.EsOpCode) as opt">
                    <h6 class="mb-1" style="color: #1c1d1d; font-weight: 500; margin-top: 5px; font-size: 0.85rem;">
                      <span *ngIf="opt.OpMin == opt.OpMax">
                         (Option {{ opt.OpCode }}:  Please select {{ opt.OpMin }} subject{{ opt.OpMin !== 1 ? 's' : '' }}).
                      </span>
                      <span *ngIf="opt.OpMin != opt.OpMax">
                         (Option {{ opt.OpCode }}:  Please select between  min {{ opt.OpMin }} and max {{ opt.OpMax }} subjects).
                      </span>
                    </h6>
                  </ng-container>
                </div>
                <mat-card-content>
                  <div *ngFor="let child of group.children">
                    <mat-checkbox [disabled]="child.EsOpCode === ' '"
                      [checked]="shouldCheckItemForGroup(child) || child.EsOpCode === ' '"
                      (change)="onCheckboxChanged($event, child)">
                      {{ child.EsCode }} - {{ child.EsName }}
                      <b *ngIf="child.EsOpCode !== ' '">(Option : {{child.EsOpCode}})</b>
                    </mat-checkbox>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- 
    <div class="mt-4">
      <ng-container *ngIf="getValidationErrorsKeys().length > 0; else optDataSection">
        <div *ngFor="let errorCode of getValidationErrorsKeys()">
          <p style="color: red;">{{ validationErrors[errorCode] }}</p>
        </div>
      </ng-container>
      <ng-template #optDataSection>
        <div class="col-sm-12" *ngFor="let opt of optData">
          <h6 class="mb-1 redCol">
            <b>For OptCode = {{opt.OpCode}} : Min = {{opt.OpMin}} And Max = {{opt.OpMax}}</b>
          </h6>
        </div>
      </ng-template>
    </div>-->

    <div class="red" *ngIf="msgShow">Note : {{Message}}</div>
    <div class="red" *ngIf="msgFail">Note : {{Message2}}</div>
  </form>
</div>
<div class="modal-footer">

  <button type="button" class="btn btn-secondary" (click)="closeDialog()">
    <i class="fa fa-times me-1"></i>
    Close
  </button>
  <button type="button" class="btn btn-primary" [disabled]="disableButton" (click)="saveSelection()">
   <i class="fa fa-save me-1"></i>
    {{ updateButton ? 'Update' : 'Save' }}
  </button>
</div>